import { useEffect, useState } from "react";
import axios from "../axios";

export default function DashboardStats() {
  const [stats, setStats] = useState({
    total_leads: 0,
    new_leads: 0,
    interested: 0,
    followup: 0,
    closed_leads: 0,
    due_today: 0,
    overdue: 0
  });

  const [orderStats, setOrderStats] = useState({
    total_orders: 0,
    confirmed_orders: 0,
    pending_orders: 0,
    cancelled_orders: 0,
    total_revenue: 0,
    today_revenue: 0,
    today_orders: 0
  });

  const loadStats = async () => {
    try {
      const res = await axios.get("/dashboard/stats");
      setStats(res.data || {});
    } catch (err) {
      console.error(err);
    }
  };

  const loadOrderStats = async () => {
    try {
      const res = await axios.get("/orders/stats");
      setOrderStats(res.data || {});
    } catch (err) {
      // orders feature might not be enabled for this user, fail silently
    }
  };

  useEffect(() => {
    loadStats();
    loadOrderStats();

    const timer = setInterval(() => {
      loadStats();
      loadOrderStats();
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const cards = [
    {
      title: "Total Leads",
      value: stats.total_leads,
      color: "bg-blue-600"
    },
    {
      title: "New Leads",
      value: stats.new_leads,
      color: "bg-gray-700"
    },
    {
      title: "Interested",
      value: stats.interested,
      color: "bg-green-600"
    },
    {
      title: "Follow-up",
      value: stats.followup,
      color: "bg-purple-600"
    },
    {
      title: "Closed",
      value: stats.closed_leads,
      color: "bg-red-600"
    },
    {
        title: "Due Today",
        value: stats.due_today,
        color: "bg-orange-600"
    },
    {
        title: "Overdue",
        value: stats.overdue,
        color: "bg-red-700"
    }
  ];

  const salesCards = [
    {
      title: "Total Orders",
      value: orderStats.total_orders || 0,
      color: "bg-indigo-600"
    },
    {
      title: "Confirmed Sales",
      value: orderStats.confirmed_orders || 0,
      color: "bg-green-600"
    },
    {
      title: "Pending Orders",
      value: orderStats.pending_orders || 0,
      color: "bg-amber-600"
    },
    {
      title: "Total Revenue",
      value: `₹${Number(orderStats.total_revenue || 0).toFixed(0)}`,
      color: "bg-emerald-700"
    },
    {
      title: "Today's Revenue",
      value: `₹${Number(orderStats.today_revenue || 0).toFixed(0)}`,
      color: "bg-teal-600"
    },
    {
      title: "Today's Orders",
      value: orderStats.today_orders || 0,
      color: "bg-cyan-700"
    }
  ];

  return (
    <div>
      <div className="grid grid-cols-7 gap-4">
        {cards.map((card) => (
          <div
            key={card.title}
            className={`${card.color} text-white rounded p-5 shadow`}
          >
            <div className="text-sm">{card.title}</div>

            <div className="text-3xl font-bold mt-2">
              {card.value || 0}
            </div>
          </div>
        ))}
      </div>

      <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mt-6 mb-3">
        AI Sales / Orders
      </h3>

      <div className="grid grid-cols-6 gap-4">
        {salesCards.map((card) => (
          <div
            key={card.title}
            className={`${card.color} text-white rounded p-5 shadow`}
          >
            <div className="text-sm">{card.title}</div>

            <div className="text-2xl font-bold mt-2">
              {card.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}